import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
   selector: '[samwebBlurOnEnter]',
})
export class BlurOnEnterDirective {
   @HostListener('keydown', ['$event'])
   public onkeydown(event): void {
      if (event.keyCode === 13 || event.keyCode === 14) {
         setTimeout(() => {
            this.el.nativeElement.blur();
         }, 200);
      }
   }

   public constructor(private el: ElementRef) {}
}
